module.exports = __webpack_public_path__ + "img/4.07.830f44f5.jpg";